import { useDispatch } from "react-redux";

import { LinkText } from "components/utility/LinkText";

import { i18n } from "services/i18nService";
import { addToReorderList } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function AddToReorderList(props) {
  const { id } = props;
  const dispatch = useDispatch();

  async function handleAddToReorderList() {
    dispatch(loadingIndicatorOn());
    const { success, message } = await addToReorderList([id]);
    if (success) {
      const message = i18n("alert.SuccessAddedToReorderList");
      dispatch(openAlert({ type: "success", message }));
      dispatch(loadingIndicatorOff());
    } else {
      dispatch(loadingIndicatorOff());
      const errorMessage = message || i18n("alert.ErrorNotAddedToReorderList");
      handleProgramError(new Error(errorMessage));
    }
  }

  return (
    <td style={{ textAlign: "center" }}>
      <LinkText onClick={handleAddToReorderList}>{i18n("global.Add")}</LinkText>
    </td>
  );
}
